import type { EntityDefinition } from "../services/entity-definition.service";

const PRIMARY_CANDIDATES = ["eventName", "name", "title", "label", "subject"];
const SECONDARY_CANDIDATES = ["eventStartDate", "modalidad", "startDate", "endDate", "category", "role", "eventType", "registrationType"];

export interface DisplayKeys {
	displayKey: string;
	secondaryKeys: string[];
}

/**
 * Resuelve que atributo mostrar como etiqueta principal (y secundarios) para los items de una
 * relacion, a partir de la definicion de la entidad relacionada. Evita que el autocomplete
 * muestre solo el UUID cuando la entidad no tiene un campo "name" (ej. Clam Evento usa eventName).
 */
export function resolveDisplayKeys(def: EntityDefinition | undefined): DisplayKeys {
	const attrs = def?.entityAttributes || [];
	const keys = new Set(attrs.map((a) => a.attributeKey));

	for (const cand of PRIMARY_CANDIDATES) {
		if (keys.has(cand)) {
			const secondary = SECONDARY_CANDIDATES.filter((c) => keys.has(c) && c !== cand);
			return { displayKey: cand, secondaryKeys: secondary.slice(0, 2) };
		}
	}

	const firstString = attrs.find((a) => a.morphedVariableType === "string" && a.attributeKey !== "id");
	if (firstString) return { displayKey: firstString.attributeKey, secondaryKeys: [] };
	return { displayKey: "name", secondaryKeys: [] };
}
